import PosSection from "views/pos";
import PosOrder from "views/pos/form";
import OrderLayout from "views/pos/OrderLayout";

const OrderRoute = {
  path: "pos",
  element: <OrderLayout />,
  children: [
    {
      path: "section",
            ref:"inventory-sales-pos",
      element: <PosSection />,
    },
    {
      path: "form",
      element: <PosOrder />,
    },
  ],
};
export default OrderRoute;
